'use strict';

import './good/pictures';
import './good/big-photo';
import './good/social-likes';
import '../../src/desktop/compatibility';
import '../../src/desktop/related-products';
import '../../src/good-one-click-buy';
import '../../libs/tabs';
import '../../src/good-tabs.js';

import {navigation} from './good/comments';

window.addGoodsComment = (goods_id, answer) => {
    import('./good/comments').then(module => {
        module.create(goods_id, answer);
    });
};

window.selectModel = id => {
    import('./good/models').then(module => {
        module.selectModel(id);
    });
};

$('.tabs a').click(function (e) {
    e.preventDefault();

    $(this).tab('show');
});

$('.cods-more').click(function () {
    const wasVisible = $('.cod-max').hasClass('cod-max2');
    $('.cod-max').toggleClass('cod-max2');

    const caption = wasVisible ? trans('good.show_all_codes') : trans('good.hide_all_codes');

    $(this).text(caption);
    return false;
});

navigation();

$('.js-track-good').click(function (ev) {
    ev.preventDefault();

    import('../../src/good-track-arrival').then(module => {
        module.default.call(this);
    });
});
